import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipList } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { Lookup } from 'src/app//shared/models/lookups/Lookup';

@Component({
  selector: 'app-tree-field',
  templateUrl: './tree-field.component.html'
})
export class TreeFieldComponent implements OnInit {
  @Input() required = false;
  @Input() isSubmitted = false;
  @Input() recordsLoading = false;
  @Input() isDisabled = false;
  @Input() recordsTree: Lookup[] = [];
  @Input() detailsSelectedRecords: any;
  @Output() selected = new EventEmitter();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  addOnBlur = false;
  selectable = true;
  removable = true;
  searchCtrl = new FormControl();
  selectedRecords: Lookup[] = [];
  showRecordsTree = false;
  // recordsLoading = false;
  @ViewChild('chipRecordsList', { static: false }) chipRecordsList!: MatChipList;
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef<HTMLInputElement>;

  constructor(private eRef: ElementRef) { }

  ngOnInit(): void {

  }

  updateSelectedRecords(data: any) {
    this.detailsSelectedRecords = [];
    this.selectedRecords = [];
    if (data) {
      data.forEach((element: Lookup) => {
        if (!element.childs && !this.isInArray(this.selectedRecords, element)) {
          this.selectedRecords.push(element);
        }
      });
      this.selected.emit(this.selectedRecords);
      /* this.searchInput.nativeElement.value = '';
      this.searchCtrl.setValue(null);
      this.filterTree(''); */
    }
  }

  isInArray(parentObj: any, item: any) {
    return parentObj.some((obj: any) => obj.id === item.id);
  }

  // dropdowns overlay events
  @HostListener('window:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.showRecordsTree = false;
    }
  }
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!event) {
      this.showRecordsTree = !this.showRecordsTree;
    } else if (!this.eRef.nativeElement.contains(event.target)) {
      this.showRecordsTree = false;
    }
    if (!this.showRecordsTree) {
      this.searchCtrl.setValue(null);
      this.filterTree('');
    } else {
      this.searchInput.nativeElement.focus();
    }
  }

  filterTree(value: any, event = false) {
    if (event) { this.showRecordsTree = true; }
    const filterValue = value.toLowerCase();
    this.recordsTree.forEach((region: Lookup) => {
      if (region.name.toLowerCase().indexOf(filterValue) === 0) {
        region.hidden = false;
      } else {
        region.hidden = true;
        if (region.childs.length) {
          region.childs.forEach((city: any) => {
            if (city.name.toLowerCase().indexOf(filterValue) === 0 && region.hidden) {
              region.hidden = false;
            }
          });
        }
      }
    });
  }

}
